import React, { useEffect, useState } from "react";
import "./index.css";
import { get } from "../../../services/ApiService.js";
import { Link } from "react-router-dom";
import BookingModal from "./BookingModal.jsx";
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const Suggestion = ({
  data,
  biomaker,
  selectedItems,
  resultRef,
  AddingToCart,
  isAddingCart,
  isRequiresManualBooking,
  ManualBooking,
  confirmLoading,
  isMailSent,
  setIsMailSent,
}) => {
  const [biomarkersList, setBiomarkersList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const FEE = 30;

  const cartItems = useSelector((state) => state.cart?.cartItems) || [];

  const isManualBooking =
    data.some((item) => item.requiresManualBooking) ||
    biomaker.some((item) => item.requiresManualBooking);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const allItems = [...data, ...biomaker];

  const getSortedItems = () => {
    const uniqueItems = [];
    const addedIds = new Set();

    // Add cart items first
    cartItems.forEach((cartItem) => {
      const match = allItems.find((item) => item._id === cartItem._id);
      if (match && !addedIds.has(match._id)) {
        uniqueItems.push(match);
        addedIds.add(match._id);
      }
    });

    // Add remaining items
    allItems.forEach((item) => {
      if (!addedIds.has(item._id)) {
        uniqueItems.push(item);
        addedIds.add(item._id);
      }
    });

    return uniqueItems;
  };

  const sortedItems = getSortedItems();

  const calculateTotals = (items) => {
    if (!items || items.length === 0)
      return { subtotal: 0, total: 0, totalDiscount: 0 };

    let totalDiscount = 0;
    let subtotal = 0;

    items.forEach((item, index) => {
      const itemPrice = Number(item.price) || 0;
      subtotal += itemPrice;
      if (index > 0) totalDiscount += 10;
    });

    const total = subtotal - totalDiscount + FEE;
    return { subtotal, total, totalDiscount };
  };

  const { subtotal, total, totalDiscount } = calculateTotals(sortedItems);

  const fetchBiomarkers = async () => {
    try {
      const res = await get("api/blood-tests/biomarkers");
      if (res.success) {
        setBiomarkersList(res.biomarkers);
      } else {
        setBiomarkersList([]);
      }
    } catch (error) {
      setBiomarkersList([]);
    }
  };

  useEffect(() => {
    fetchBiomarkers();
  }, []);

  return (
    <div className="mt-3 px-lg-4">
      <div className="row g-5">
        <div className="col-lg-12">
          <div className="card border-0 border-main rounded-4 shadow-c">
            <div className="card-body">
              <p className="metropill text-black fw-normal fs-14 mt-4">
                Our Recommendation
              </p>
              {sortedItems.map((item, index) => {
                const {
                  _id,
                  name,
                  biomarkers,
                  additionalInformation,
                  price,
                  description,
                  requiresManualBooking,
                } = item;

                const displayPrice =
                  index === 0 ? price : Math.max(price - 10, 0);
                const isDiscountApplied = displayPrice < price;

                const biomarkerElements = biomarkers
                  ? biomarkers.map((biomarkerId, bioIndex) => {
                      const itemExist = selectedItems.find(
                        (i) => i.id === biomarkerId._id
                      );
                      const bioName = biomarkerId.name;

                      return (
                        <div
                          className={`${
                            itemExist ? "tag-btnpro" : "tag-btn"
                          } text-decoration-none text-capitalize`}
                          key={bioIndex}
                          style={{ cursor: "default" }}
                        >
                          {bioName || "Unknown Biomarker"}
                        </div>
                      );
                    })
                  : null;

                return (
                  <React.Fragment key={_id}>
                    <div className="d-flex align-items-center justify-content-between flex-column flex-md-row align-items-center">
                      <div className="mt-5">
                        <h5 className="fw-semibold text-center text-md-start">
                          {name}
                        </h5>
                      </div>
                      <h4 className="text-center">
                        {isDiscountApplied && (
                          <sup style={{ fontSize: "15px", color: "#666363" }}>
                            <del className="del-line-color">£ {price}</del>
                          </sup>
                        )}
                        <span
                          className="fw-semibold"
                          style={{ fontSize: "25px" }}
                        >
                          <small>£{displayPrice}</small>
                        </span>
                      </h4>
                    </div>
                    <div className="col-12">
                      {requiresManualBooking && (
                        <p
                          className="metropill text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          DUE TO THE SAMPLE REQUIREMENTS ON THIS TEST, PLEASE
                          CLICK BELOW TO SEND US AN EMAIL FOR BOOKING
                          AVAILABILITY.
                        </p>
                      )}
                    </div>
                    <div className="mt-5 d-flex align-items-center gap-4 flex-wrap">
                      {biomarkerElements}
                    </div>
                    <hr />
                  </React.Fragment>
                );
              })}

              <div className="row total-row mb-4">
                <div className="col-lg-6 col-md-6 col-sm-12"></div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="cart-totals">
                    <div className="row total-row">
                      <div className="col-5 totel-left-heading">
                        <span>Blood Draw Fee</span>{" "}
                      </div>
                      <div className="col-7 totel-right-content">
                        <span className="fs-18">£ {FEE}</span>{" "}
                      </div>
                    </div>
                    <div className="row total-row">
                      <div className="col-5 totel-left-heading">
                        {" "}
                        <span>Discount</span>
                      </div>
                      <div className="col-7 totel-right-content">
                        <span className="fs-18"> - £ {totalDiscount}</span>{" "}
                      </div>
                    </div>

                    <div className="row total-row">
                      <div className="col-5 totel-left-heading">
                        <span className="fw-bold">Total</span>{" "}
                      </div>
                      <div className="col-7 totel-right-content">
                        {" "}
                        <b className=" text-dark fs-18 fw-bold">£ {total}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-5 pt-5">
                {isManualBooking ? (
                  <>
                    <p
                      className="metropill text-danger"
                      style={{
                        color: "#333",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      Due to the requirements for one or more of your tests,
                      the sample must reach the lab in a timely manner after
                      taking your blood. Please click below to email this
                      package to our team. Once received, we will reach out to
                      schedule your appointment according to the sample
                      requirements.
                    </p>
                    <button
                      type="button"
                      className={`${
                        isMailSent ? "btn-gray" : "btn-pink"
                      } w-100`}
                      onClick={showModal}
                      disabled={isMailSent}
                    >
                      {isMailSent ? "Email Sent" : "Send Email"}
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    className="btn-pink w-100"
                    onClick={() => AddingToCart(sortedItems)}
                    disabled={isAddingCart}
                  >
                    {isAddingCart && (
                      <LoadingOutlined className="colorload" />
                    )}{" "}
                    Add to cart
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BookingModal
        isVisible={isModalVisible}
        onClose={handleCancel}
        ManualBooking={ManualBooking}
        confirmLoading={confirmLoading}
        selectedItems={selectedItems}
      />
    </div>
  );
};

export { Suggestion };
